<template lang="pug">
div(v-if="projekt")
  mein-projekt(:onlyProjectId="isAuthorized && projektId")

</template>

<script>
import gql from 'graphql-tag'
import MeinProjekt from '../mein-projekt'
import { user } from '../../router'

export default {
  props: ['extra'],
  components: {
    MeinProjekt
  },
  data() {
    return {
      user
    }
  },
  apollo: {
    projekte: {
      query: gql`query ExtraPDetailsVueProjekte($p: String) {
        projekte(where: { personalSchluessel: $p }) {
          id
        }
      }`,
      skip() {
        return !this.isAuthorized || !this.$route.params.slug
      },
      variables() {
        return {
          p: this.$route.params.slug
        }
      },
    },
  },
  computed: {
    projektId() {
      return this.projekt && this.projekt.id
    },
    isAuthorized() {
      const user = this.user
      if (user && user.person && user.person.vorstand || user.person.bereichsleitung || user.person.abteilungsleitung || user.person.ticketBearbeiter) {
        return true
      } else {
        return false
      }
    },
    projekt() {
      return this.projekte && this.projekte[0]
    },
  },
}
</script>
